import { useL10n } from "@ews/react-localization-context";
import { FC, useMemo } from "react";
import
{
    Navbar,
    NavbarLink
} from "./Navbar";

import { LicenseType, SystemType } from "@ews/react-data";
import Icon from "@ews/react-icons";
import { AuthorizationLevel } from "@ews/zlt-events";
import
{
    apps,
    informationCircleSharp,
    menu
} from "ionicons/icons";
import { iif } from "../../../utils";
import { useAuthorization } from "../../Authorization";
import { useHasLicense } from "../../HasLicense";
import { useMyPermissions } from "../../Login/LoginProvider";
import { useNamedRoutes } from "../../NamedRoutes";
import { useCurrentSystem } from "../../ReactData/system";
import { useIsMobile } from "../../Responsive";
import { MenuToggleProps } from "../types";

const System: FC<MenuToggleProps> = ({ onMenuToggle }) =>
{
    const system = useCurrentSystem();
    const { translate: t } = useL10n();
    const { generate } = useNamedRoutes();

    const isMobile = useIsMobile();
    const permissions = useMyPermissions();
    const { authorizationLevel } = useAuthorization();

    const hasDetailsViewLicense = useHasLicense(LicenseType.DETAIL_VIEW);
    const hasPlanLicense = useHasLicense(LicenseType.PLAN_VIEW);

    const hasListViewAccessLevel1Permission = useMemo(() => permissions.listViewAccessLevel1 !== undefined || permissions.listViewAccessLevel1 !== null, [permissions.listViewAccessLevel1]);

    const color = isMobile ? 'secondary' : 'light';

    return (
        <Navbar
            onMenuToggle={onMenuToggle}
            color={color}
        >
            <NavbarLink
                show={hasListViewAccessLevel1Permission}
                /* show={!isMobile} */
                icon={iif(isMobile, informationCircleSharp)}
                title={t('COM_FACPMANAGEMENT_LOGS_EVENTS_DETAILS') as string}
                link={generate('system')}
            />
            <NavbarLink
                show={hasListViewAccessLevel1Permission}
                disabled={!(hasDetailsViewLicense || isMobile)}
                icon={iif(isMobile, apps)}
                title={t('[SID_MNU_HK_EVENTS]') as string}
                link={generate('system:events', { page: "0" })}
            />
            <NavbarLink
                disabled={!hasDetailsViewLicense}
                show={
                    hasListViewAccessLevel1Permission ?
                        !(isMobile || system.systemType === SystemType.BC216) :
                        false
                }
                icon={iif(isMobile, apps)}
                title={`${t('[SID_MNU_HK_EVENTS]')} 2` as string}
                link={generate('system:events-page2')}
            />
            <NavbarLink
                disabled={!hasDetailsViewLicense}
                show={
                    isMobile ?

                        hasDetailsViewLicense

                        : hasListViewAccessLevel1Permission ?
                            (permissions.listViewAccessLevel1! || (authorizationLevel > AuthorizationLevel.LEVEL1)) :
                            false
                }
                icon={iif(isMobile, menu)}
                title={t('[REACT_ELEMENTS]') as string}
                link={generate('system:elements', { page: "0" })}
            />
            {hasPlanLicense ?
                <NavbarLink
                    icon={iif(isMobile, <Icon icon="plan" width={30} height={30} />)}
                    title={t('TD_PLAN') as string}
                    link={generate('system:plan')}
                />
                : null}
        </Navbar>
    );

};

export default System;
